import React, { useState, useEffect } from 'react';
import ProjectModal from './ProjectModal';
import './Projects.css';

const Projects = () => {
  const [selectedProject, setSelectedProject] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [columns, setColumns] = useState(3);
  const [isDarkMode, setIsDarkMode] = useState(true);

  const projects = [
  {
    id: "1",
    img: "/images/video.png",
    title: "Video Chat App",
    description: "Zoom-like video meeting platform with authentication and real-time WebRTC communication.",
    githubUrl: "#",
    liveUrl: "#",
    tags: ["React", "Socket.IO", "Node.js", "Express"],
    accentColor: "#6C5CE7"
  },
  {
    id: "2",
    img: "/images/stock.png",
    title: "Stock Tracker",
    description: "Stock market dashboard with real-time updates, charts, and price analysis.",
    githubUrl: "#",
    liveUrl: "#",
    tags: ["React", "API", "Chart.js"],
    accentColor: "#00B894"
  },
  {
    id: "3",
    img: "/images/git.png",
    title: "GitHub Repo Finder",
    description: "A sleek GitHub repository search tool with user profiles and starred repo display.",
    githubUrl: "#",
    liveUrl: "#",
    tags: ["React", "GitHub API", "TailwindCSS"],
    accentColor: "#0984E3"
  },
  {
    id: "4",
    img: "/images/rent.png",
    title: "Rental Listing Web App",
    description: "Rental portal with dynamic listings, filters, and user authentication.",
    githubUrl: "#",
    liveUrl: "#",
    tags: ["React", "Firebase", "Auth"],
    accentColor: "#E17055"
  },
  {
    id: "5",
    img: "/images/health.jpg",
    title: "Smart Health Analyzer",
    description: "Healthcare app that extracts and analyzes medical reports using OCR and AI for hospital suggestions.",
    githubUrl: "#",
    liveUrl: "#",
    tags: ["MERN", "OCR", "AI", "TailwindCSS"],
    accentColor: "#D63031"
  },
  {
    id: "6",
    img: "/images/eco.jpg",
    title: "EcoCart – Sustainable Assistant",
    description: "A full-stack shopping assistant that suggests eco-friendly products using AI and Firebase auth.",
    githubUrl: "#",
    liveUrl: "#",
    tags: ["MongoDB", "Express.js", "React", "Node.js", "Firebase", "Bootstrap"],
    accentColor: "#00CEC9"
  }
];


  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) setColumns(1);
      else if (window.innerWidth < 1024) setColumns(2);
      else setColumns(3);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <section className={`projects-section ${isDarkMode ? 'dark-theme' : ''}`} id="projects">
      <div className="container">
        <div className="theme-toggle" onClick={() => setIsDarkMode(!isDarkMode)}>
          {/* {isDarkMode ? '☀️' : '🌙'} */}
        </div>
        
        <h2 className="section-title">My Projects</h2>
        <p className="section-subtitle">Explore my recent work</p>
        
        <div className="projects-grid" style={{ '--columns': columns }}>
          {projects.map((project) => (
            <div 
              key={project.id}
              className="project-card"
              onClick={() => {
                setSelectedProject(project);
                setIsModalOpen(true);
              }}
              style={{ '--accent-color': project.accentColor }}
            >
              <div className="project-image-container">
                <img 
                  src={project.img} 
                  alt={project.title} 
                  loading="lazy"
                  className="project-image"
                />
                <div className="project-overlay">
                  <h3>{project.title}</h3>
                  <div className="project-tags">
                    {project.tags.map((tag, index) => (
                      <span key={index}>{tag}</span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {isModalOpen && (
        <ProjectModal 
          project={selectedProject} 
          onClose={() => setIsModalOpen(false)}
          isDarkMode={isDarkMode}
        />
      )}
    </section>
  );
};

export default Projects;